module.exports = __webpack_public_path__ + "img/logo-keyvue-basic.2d84ef80.svg";